import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import Button from "react-bootstrap/Button";


import FldCloseIcon from "../images/round-close-icon.svg";

import ValidationAlertIcon from "../images/validation-alert-icon.svg";
const GetYourAgent = () => {
 


  return (
    <div className="gitcha-main-wrapper pb-0 bg-grey-variant">

   <div className="content-wrapper vh-100">
   <div className="inner-layout-header-new bg-transparent">
     <div className="review-plan-header w-100">
      <div className="signup-login-header-top signup-header-txt clearfix">
          <a className="back-link" href="#"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z" fill="#1B1C1E"/>
          </svg></a>


          

        </div>

        </div>
      
      
        </div>
        <div className="inner-layout-content-new h-100">
        <div className="get-agent-wrap clearfix">
        
        
          <h2>Let’s get your agent info</h2>
          <p>These details will be shown to clients after an introduction has been accepted. It will remain anonymous until then.</p>
        
        <div className="row">
        <div className="col-6 pe-2">
        <div className="mob-fld-wrap position-relative mb-2">
          <label className="form-label">First name <span>*</span></label>
          <input type="text" className="form-control mob-pr-44 validation-alert-brdr" name="firstname-fld" placeholder="First name" />
          <Button variant="" className="fld-close-btn"><img src={FldCloseIcon} /></Button>
          <div className="validation-alert"><img src={ValidationAlertIcon} /></div>
          <div className="mob-error-msg">Invalid first name</div>
        </div>
        </div>
        <div className="col-6 ps-2">
        <div className="mob-fld-wrap position-relative mb-2">
          <label className="form-label">Last name <span>*</span></label>
          <input type="text" className="form-control mob-pr-44 validation-alert-brdr" name="lastnaem-fld" placeholder="Last name" />
          <Button variant="" className="fld-close-btn"><img src={FldCloseIcon} /></Button>
          <div className="validation-alert"><img src={ValidationAlertIcon} /></div>
          <div className="mob-error-msg">Invalid last name</div>
        </div>

        </div>


        <div className="col-12">
        <div className="mob-fld-wrap position-relative mb-2">
          <label className="form-label">Location <span>*</span></label>
          <input type="text" className="form-control mob-pr-44 validation-alert-brdr" name="location-fld" placeholder="City, State" />
          <Button variant="" className="fld-close-btn"><img src={FldCloseIcon} /></Button>
          <div className="validation-alert"><img src={ValidationAlertIcon} /></div>
          <div className="mob-error-msg">Invalid location</div>
        </div>
       </div>
       <div className="col-12">
        <div className="mob-fld-wrap position-relative mb-2">
          <label className="form-label">Company/Agency <span>*</span></label>
          <input type="text" className="form-control mob-pr-44 validation-alert-brdr" name="company-fld" placeholder="Company or agency name" />
          <Button variant="" className="fld-close-btn"><img src={FldCloseIcon} /></Button>
          <div className="validation-alert"><img src={ValidationAlertIcon} /></div>
          <div className="mob-error-msg">Invalid company</div>
        </div>
       </div>
       <div className="col-12">
        <div className="mob-fld-wrap position-relative mb-2">
          <label className="form-label">License number <span>*</span></label>
          <input type="text" className="form-control mob-pr-44 validation-alert-brdr" name="license-fld" placeholder="License number" />
          {/*<Button variant="" className="fld-close-btn"><img src={FldCloseIcon} /></Button>*/}
          <Button variant="" className="btn search-box-btn">Search</Button>
          <div className="mob-error-msg">Invalid license number</div>
        </div>
       </div>
        
        
        {/*<div className="col-12">
        <label class="form-check-label checkbox-label mb-28" for="IAmRepresenting1">
          <input class="form-check-input" type="checkbox" id="IAmRepresenting1" />
          I'm a real-estate professional
        </label>
  </div>*/}
        </div>
         
        <Button variant="primary" className="btn w-100 mb-4" disabled>Continue</Button>

        </div>

        

        
        
        
        
        
                       
        
      </div>

    </div>
    
        
    </div>
  );
};

export default GetYourAgent;
